jQuery.event.special.touchstart = {
  setup: function (_, ns, handle) {
    if (ns.includes("noPreventDefault")) {
      this.addEventListener("touchstart", handle, { passive: false });
    } else {
      this.addEventListener("touchstart", handle, { passive: true });
    }
  },
};

jQuery.event.special.touchmove = {
  setup: function (_, ns, handle) {
    if (ns.includes("noPreventDefault")) {
      this.addEventListener("touchmove", handle, { passive: false });
    } else {
      this.addEventListener("touchmove", handle, { passive: true });
    }
  },
};

/**** Main menu ****/

var $burger = $(".hamburger-wrapper");
var $nav = $(".navigation-wrapper");

function openNav() {
  $burger.addClass("is-active").attr("aria-expanded", "true");
  $(".header-container").addClass("navi-open");
  $nav.addClass("navi-open");
  $("body").addClass("navi-open");

  trapFocus();
}

function closeNav() {
  $burger.removeClass("is-active").attr("aria-expanded", "false");
  $(".header-container").removeClass("navi-open");
  $nav.removeClass("navi-open");
  $("body").removeClass("navi-open");

  releaseFocus();
}

function toggleNav() {
  if ($burger.hasClass("is-active")) {
    closeNav();
  } else {
    openNav();
  }
}

// ✅ Click
$burger.on("click", function (e) {
  e.preventDefault();
  toggleNav();
});

// ✅ Enter / Space
$burger.on("keydown", function (e) {
  var isEnter = e.key === "Enter" || e.keyCode === 13;
  var isSpace = e.key === " " || e.keyCode === 32;

  if (!isEnter && !isSpace) return;

  e.preventDefault();
  toggleNav();
});

// ✅ ESC closes menu
$(document).on("keydown", function (e) {
  if (e.key === "Escape" && $burger.hasClass("is-active")) {
    closeNav();
    $burger.focus();
  }
});

// ✅ TAB-OUT AUTO CLOSE (FOCUS TRAP)
function trapFocus() {
  var $focusable = $nav.find("a, button, [tabindex]:not([tabindex='-1'])");

  if (!$focusable.length) return;

  var $first = $focusable.first();
  var $last = $focusable.last();

  // TAB from last element → close menu
  $last.on("keydown.menu", function (e) {
    if (e.key === "Tab" && !e.shiftKey) {
      closeNav();
    }
  });

  // SHIFT+TAB from first element → close menu
  $first.on("keydown.menu", function (e) {
    if (e.key === "Tab" && e.shiftKey) {
      closeNav();
    }
  });
}

function releaseFocus() {
  $nav.find("*").off("keydown.menu");
}

var $lang = $("#lang");
var $langTrigger = $lang.find(".lang-active");

function closeLangDropdown() {
  $lang.removeClass("open");
  $langTrigger.attr("aria-expanded", "false");
}

function openLangDropdown() {
  $lang.addClass("open");
  $langTrigger.attr("aria-expanded", "true");
}

function toggleLangDropdown() {
  if ($lang.hasClass("open")) {
    closeLangDropdown();
  } else {
    openLangDropdown();
  }
}

$(document).on("click", "#lang .lang-active", function (e) {
  e.preventDefault();
  e.stopPropagation();
  toggleLangDropdown();
});

$(document).on("keydown", "#lang .lang-active", function (e) {
  var isEnter = e.key === "Enter" || e.keyCode === 13;
  var isSpace = e.key === " " || e.keyCode === 32;

  if (!isEnter && !isSpace) return;

  e.preventDefault();
  toggleLangDropdown();
});

$(document).on("click", function (e) {
  if (!$(e.target).closest("#lang").length) {
    closeLangDropdown();
  }
});

$(document).on("click", "#lang .lang-navi a", function () {
  closeLangDropdown();
});

$(document).on("keydown", function (e) {
  if (e.key === "Escape" && $lang.hasClass("open")) {
    closeLangDropdown();
    $langTrigger.focus();
  }
});

$(window).on("scroll resize", function () {
  if ($(window).width() < 1200 && $(window).scrollTop() > 50) {
    $(".hamburger-wrapper").addClass("is-scrolled");
  } else {
    $(".hamburger-wrapper").removeClass("is-scrolled");
  }
});

function closeSubmenu($li, $btn) {
  $li.removeClass("open");
  $btn.attr("aria-expanded", "false");
  $li.find("ul.level2").hide();
}

$(document).on("click keydown", ".show-more", function (e) {
  var isClick = e.type === "click";
  var isEnter = e.key === "Enter" || e.keyCode === 13;
  var isSpace = e.key === " " || e.keyCode === 32;

  if (!isClick && !isEnter && !isSpace) return;
  e.preventDefault();

  var $btn = $(this);
  var $li = $btn.closest("li.level1");
  var $submenu = $li.find("ul.level2");
  var isOpen = $li.hasClass("open");

  if (!isOpen) {
    // OPEN
    $submenu.show();
    $li.addClass("open");
    $btn.attr("aria-expanded", "true");

    // Handle TAB-out
    var $focusable = $li
      .find("ul.level2")
      .find("a, button, [tabindex]:not([tabindex='-1'])");

    if ($focusable.length) {
      var $first = $focusable.first();
      var $last = $focusable.last();

      // TAB on last item closes the submenu
      $last.on("keydown.submenu", function (ev) {
        if (ev.key === "Tab" && !ev.shiftKey) {
          closeSubmenu($li, $btn);
        }
      });

      // SHIFT+TAB on toggle button closes submenu
      $btn.on("keydown.submenu", function (ev) {
        if (ev.key === "Tab" && ev.shiftKey) {
          closeSubmenu($li, $btn);
        }
      });
    }
  } else {
    // CLOSE
    closeSubmenu($li, $btn);
    $btn.off("keydown.submenu");
    $li.find("ul.level2 a").off("keydown.submenu");
  }
});

/**** Main menu end ****/

AOS.init();

$(function () {
  if ($(".reviews-slider").length > 0) {
    new Splide(".reviews-slider", {
      pagination: false,
      arrows: false,
      drag: true,
      autoplay: false,
      speed: 3000,
      rewind: true,
      perPage: 3,
      gap: "32px",
      breakpoints: {
        690: {
          perPage: 1,
        },
        1000: {
          perPage: 2,
        },
      },
    }).mount();
  }
});

var hasAnimatedNumbers = false;

function animateNumbers() {
  var $section = $(".content-numbers");

  // If element doesn't exist, stop function completely
  if ($section.length === 0) return;

  if (hasAnimatedNumbers) return;

  var elementTop = $section.offset().top;
  var elementHeight = $section.outerHeight();
  var scrollTop = $(window).scrollTop();
  var windowHeight = $(window).height();

  // Check if the element is in view
  if (scrollTop + windowHeight > elementTop + elementHeight / 4) {
    hasAnimatedNumbers = true;

    $section.find(".number").each(function () {
      var $this = $(this);
      var target = parseInt($this.text(), 10);

      $this.prop("Counter", 0).animate(
        { Counter: target },
        {
          duration: 1500,
          easing: "swing",
          step: function (now) {
            $this.text(Math.floor(now));
          },
          complete: function () {
            $this.text(target);
          },
        }
      );
    });
  }
}

$(window).on("scroll", animateNumbers);
animateNumbers();
